import { useNavigate } from 'react-router-dom';
import { useTenantScope } from '../context/TenantScopeContext';

// Nome del tenant cliccabile nelle griglie cross-tenant (richiesta dell'utente, 26/10/2026): apre
// quel tenant come fa l'elenco Tenants, cioè lo seleziona come scope e porta alla sua Overview.
export default function TenantLink({ tenantId, name }: { tenantId: number | null | undefined; name: string | null | undefined }) {
  const { setSelectedTenantId } = useTenantScope();
  const navigate = useNavigate();
  if (!tenantId) return <span className="text-gray-500">{name}</span>;
  return (
    <button
      onClick={e => { e.stopPropagation(); setSelectedTenantId(tenantId); navigate('/overview'); }}
      title={`Open ${name}`}
      className="text-primary-700 hover:underline text-left"
    >
      {name}
    </button>
  );
}
